import React from 'react';
import { Link } from 'react-router-dom';
import './Logo.css';

const Logo = ({ className = '', onClick }) => {
  return (
    <Link to="/" className={`logo ${className}`} onClick={onClick}>
      <div className="logo-container">
        <div className="logo-icon">
          <svg 
            className="logo-svg" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" 
              fill="#ffffff"
            />
          </svg>
        </div>
        <div className="logo-brand">
          <span className="logo-name">LogCrest</span>
        </div>
      </div>
    </Link>
  );
};

export default Logo;
